import { NAME } from './constants';

export const BULK_UPDATE_ITEMS = `${NAME}/BULK_UPDATE_ITEMS`;
export const BULK_UPDATE_ITEMS_FAILURE = `${NAME}/BULK_UPDATE_ITEMS_FAILURE`;
export const BULK_UPDATE_ITEMS_SUCCESS = `${NAME}/BULK_UPDATE_ITEMS_SUCCESS`;

export const DELETE_ITEM = `${NAME}/DELETE_ITEM`;
export const DELETE_ITEM_SUCCESS = `${NAME}/DELETE_ITEM_SUCCESS`;
export const DELETE_ITEM_FAILURE = `${NAME}/DELETE_ITEM_FAILURE`;

export const FETCH_ITEMS = `${NAME}/FETCH_ITEMS`;
export const FETCH_ITEMS_FAILURE = `${NAME}/FETCH_ITEMS_FAILURE`;
export const FETCH_ITEMS_SUCCESS = `${NAME}/FETCH_ITEMS_SUCCESS`;

export const FETCH_ITEM_DETAIL = `${NAME}/FETCH_ITEM_DETAIL`;
export const FETCH_ITEM_DETAIL_FAILURE = `${NAME}/FETCH_ITEM_DETAIL_FAILURE`;
export const FETCH_ITEM_DETAIL_SUCCESS = `${NAME}/FETCH_ITEM_DETAIL_SUCCESS`;

export const FETCH_POLITICAL_DIVISIONS1 = `${NAME}/FETCH_POLITICAL_DIVISIONS1`;
export const FETCH_POLITICAL_DIVISIONS1_FAILURE = `${NAME}/FETCH_POLITICAL_DIVISIONS1_FAILURE`;
export const FETCH_POLITICAL_DIVISIONS1_SUCCESS = `${NAME}/FETCH_POLITICAL_DIVISIONS1_SUCCESS`;

export const FETCH_POLITICAL_DIVISIONS2 = `${NAME}/FETCH_POLITICAL_DIVISIONS2`;
export const FETCH_POLITICAL_DIVISIONS2_FAILURE = `${NAME}/FETCH_POLITICAL_DIVISIONS2_FAILURE`;
export const FETCH_POLITICAL_DIVISIONS2_SUCCESS = `${NAME}/FETCH_POLITICAL_DIVISIONS2_SUCCESS`;

export const INITIALIZE_FORM = `${NAME}/INITIALIZE_FORM`;
export const RESET = `${NAME}/RESET`;
export const RESET_FORM = `${NAME}/RESET_FORM`;

export const OPEN_PRODUCT_FORM = `${NAME}/OPEN_PRODUCT_FORM`;

export const SAVE = `${NAME}/SAVE`;
export const SAVE_SUCCESS = `${NAME}/SAVE_SUCCESS`;
export const SAVE_FAILURE = `${NAME}/SAVE_FAILURE`;

export const SET_IS_NEW_RECORD = `${NAME}/SET_IS_NEW_RECORD`;
export const SET_ENABLED_EDITION = `${NAME}/SET_ENABLED_EDITION`;

export const UPDATE_ITEMS_SUCCESS = `${NAME}/UPDATE_ITEMS_SUCCESS`;
